import { observer } from 'mobx-react-lite'
import { type PendingTeamMembersViewModel } from '@/features/iam/teams/PendingTeamMembersViewModel'
import { PendingMembersTable } from '@/features/iam/teams/components/PendingMembersTable'

export interface PendingMembersTableContainerProps {
  vm: PendingTeamMembersViewModel
}

export const PendingMembersTableContainer = observer(
  function PendingMembersTableContainer({
    vm,
  }: PendingMembersTableContainerProps) {
    return (
      <PendingMembersTable
        rows={vm.filtered.map((pendingMember) => ({
          email: pendingMember.email,
          avatar: pendingMember.avatar,
          dateCreated: pendingMember.dateCreated,
          expires: pendingMember.expires,
        }))}
        currentSort={vm.sortField}
        currentSortOrder={vm.sortOrder}
        onSort={vm.setSort}
      />
    )
  },
)
